/* Display a coupon price only after Shopify confirms an all-products percentage discount. */
(() => {
  'use strict';
  let applied = null;
  let scheduled = false;
  let validating = false;
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const endpoint = name => root.replace(/\/?$/, '/') + name;

  function money(cents) {
    if (window.wpbingo && wpbingo.Currency && wpbingo.strings && wpbingo.strings.moneyFormat) {
      return wpbingo.Currency.formatMoney(cents, wpbingo.strings.moneyFormat);
    }
    const locale = document.documentElement.lang || 'en-GB';
    const currency = (window.routes && window.routes.shop_currency) || 'EUR';
    return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(cents / 100);
  }

  function eligibleApplication(cart) {
    const candidates = [...(cart.cart_level_discount_applications || [])];
    for (const item of cart.items || []) {
      for (const allocation of item.line_level_discount_allocations || []) {
        if (allocation.discount_application) candidates.push(allocation.discount_application);
      }
    }
    return candidates.find(app =>
      app.type === 'discount_code' &&
      app.value_type === 'percentage' &&
      app.target_selection === 'all' &&
      app.target_type === 'line_item' &&
      Number(app.value) > 0 && Number(app.value) < 100 && app.title
    );
  }

  function updateFromCart(cart) {
    const app = eligibleApplication(cart);
    applied = app ? { code: app.title, percent: Number(app.value) } : null;
    schedule();
  }

  function parsePrice(text) {
    const groups = String(text).replace(/[^\d,.]/g, '').match(/[\d,.]+/g);
    if (!groups || !groups.length) return null;
    let value = groups[0];
    const comma = value.lastIndexOf(',');
    const dot = value.lastIndexOf('.');
    const separator = Math.max(comma, dot);
    if (separator >= 0 && value.length - separator - 1 === 2) {
      value = value.slice(0, separator).replace(/\D/g, '') + '.' + value.slice(separator + 1);
    } else {
      value = value.replace(/\D/g, '');
    }
    const euros = Number(value);
    return Number.isFinite(euros) ? Math.round(euros * 100) : null;
  }

  function renderOne(container, original) {
    const existing = container.querySelector(':scope > .besunset-coupon-price');
    if (!applied) {
      if (existing) existing.remove();
      container.classList.remove('besunset-coupon-active');
      return;
    }
    const base = parsePrice(original.textContent) || Number(container.dataset.discountBasePrice || original.dataset.discountBasePrice);
    if (!base || base < 1) return;
    const final = Math.round(base * (1 - applied.percent / 100));
    const signature = `${base}|${final}|${applied.code}`;
    if (existing && existing.dataset.signature === signature) return;
    if (existing) existing.remove();
    const display = document.createElement('span');
    display.className = 'besunset-coupon-price';
    display.dataset.signature = signature;
    const before = document.createElement('s');
    before.className = 'besunset-coupon-before';
    before.textContent = money(base);
    const after = document.createElement('strong');
    after.className = 'besunset-coupon-after';
    after.textContent = money(final);
    const code = document.createElement('small');
    code.className = 'besunset-coupon-code';
    code.textContent = applied.code;
    display.append(before, after, code);
    container.append(display);
    container.classList.add('besunset-coupon-active');
  }

  function render() {
    document.querySelectorAll('.price-container[data-price-container]').forEach(container => {
      const original = container.querySelector('.js-product-price');
      if (original) renderOne(container, original);
    });
    document.querySelectorAll('.product-card__price').forEach(container => {
      const prices = [...container.querySelectorAll('.product-group-price .product-price:not(.product-price--regular)')];
      const original = prices.find(el => el.offsetParent !== null) || prices[0];
      if (original) renderOne(container, original);
    });
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.setTimeout(() => { scheduled = false; render(); }, 80);
  }

  async function fetchCart() {
    try {
      const response = await fetch(endpoint('cart.js'), { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) return;
      updateFromCart(await response.json());
    } catch (_) { /* Keep normal prices if validation is unavailable. */ }
  }

  async function validateCode(code) {
    if (validating) return;
    validating = true;
    applied = null;
    schedule();
    try {
      const response = await fetch(endpoint('cart/update.js'), {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: code.trim() })
      });
      if (response.ok) updateFromCart(await response.json());
    } catch (_) { /* Shopify checkout remains the source of truth. */ }
    validating = false;
  }

  document.addEventListener('change', event => {
    if (event.target.matches('.discount_code_input')) validateCode(event.target.value || '');
  });
  document.addEventListener('click', event => {
    if (!event.target.closest('.save-discount_code_input')) return;
    const input = document.querySelector('.discount_code_input');
    if (input) validateCode(input.value || '');
  });
  const observer = new MutationObserver(mutations => {
    if (mutations.some(m => !m.target.closest?.('.besunset-coupon-price'))) schedule();
  });
  observer.observe(document.documentElement, { subtree: true, childList: true, characterData: true });
  fetchCart();
  document.addEventListener('visibilitychange', () => { if (!document.hidden) fetchCart(); });
})();
